import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { useColorToMuiColor } from '../../hooks/useColorToMuiColor.hook';
import { iconToMuiIcon } from '../../utils/icon-to-mui-icon.util';

import type { extractCompatibleStateGroups } from './utils/resolve-compatible-states.util';

interface CompatibleStateChipsProps {
  readonly states: ReturnType<
    typeof extractCompatibleStateGroups
  >[number]['states'];
}

export const CompatibleStateChips = ({
  states,
}: Readonly<CompatibleStateChipsProps>) => {
  const { colorToMuiColor } = useColorToMuiColor();

  return (
    <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }} useFlexGap>
      {states.map((state) => (
        <Chip
          icon={state.icon ? iconToMuiIcon(state.icon) : undefined}
          key={state.id}
          label={state.label}
          sx={
            state.color
              ? {
                  bgcolor: colorToMuiColor(state.color),
                  color: 'common.white',
                  '& .MuiChip-icon': { color: 'common.white' },
                }
              : undefined
          }
        />
      ))}
    </Stack>
  );
};
